import { render, staticRenderFns } from "./Dialog_DistributionStudent.vue?vue&type=template&id=3eed19ba&scoped=true&"
import script from "./Dialog_DistributionStudent.vue?vue&type=script&lang=js&"
export * from "./Dialog_DistributionStudent.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_DistributionStudent.vue?vue&type=style&index=0&id=3eed19ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eed19ba",
  null
  
)

export default component.exports